import { ReactElement } from 'react';
import { Field } from 'formik';

import { Label } from '../Label/Label';
import { TextInput } from '../TextInput/TextInput';
import { validateField } from '../../utils/validations';
import { getDataTest } from '../../utils/dataTests';

// @deprecated - use components/TextInput/FormikTextInput
export interface TextFieldProps {
    name: string;
    variant: string;
    label?: string | Array<string>;
    placeholder?: string;
    suffix?: string;
    className?: string;
    min?: number | string | null;
    max?: number | string | null;
    error?: string;
    optional?: boolean;
    onHelpClick?: () => void;
    allowFieldValidation?: boolean;
}

export const TextField = ({
    name,
    variant,
    label,
    placeholder,
    suffix,
    className,
    min,
    max,
    error,
    optional,
    onHelpClick,
    allowFieldValidation,
    ...props
}: TextFieldProps): ReactElement => {
    const renderLabel = (label: string | Array<string>, id: string) => {
        if (typeof label === 'object') {
            return (
                <Label htmlFor={id} description={label[1]} data-test={getDataTest(props, 'Label')}>
                    {label[0]}
                </Label>
            );
        } else {
            return (
                <Label htmlFor={id} onHelpClick={onHelpClick} data-test={getDataTest(props, 'Label')}>
                    {label}
                </Label>
            );
        }
    };

    return (
        <div className={className}>
            {label && renderLabel(label, name)}
            <Field
                name={name}
                id={name}
                placeholder={placeholder}
                suffix={suffix}
                variant={variant}
                component={TextInput}
                error={error}
                max={max}
                validate={(value: string | number) =>
                    (allowFieldValidation || allowFieldValidation === undefined) &&
                    validateField(value, optional, min, max, variant)
                }
                data-test={getDataTest(props)}
            />
        </div>
    );
};
